import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { InputComponent } from '@app/modules/change-requests/interfaces/input-component.class';
import { AuthService } from '@app/services';
import { Employee } from '@models/employee/employee.model';

@Component({
    selector: 'reports-to-input-component',
    template: `
        <div *ngIf="!isLoading" class="reports-to-input-field">
            <mat-form-field class="no-labels no-helpers">
                <ui-employee-autocomplete
                    [disabled]="disabled"
                    [(ngModel)]="reportsTo"
                    [aria-label]="ariaLabel"
                    name="reportsTo"
                    (blur)="handleChange()"
                    [errorStateMatcher]="errorStateMatcher"
                ></ui-employee-autocomplete>
                <mat-error>
                    {{ errorMessage }}
                </mat-error>
            </mat-form-field>
        </div>
    `,
})
export class ReportsToInputComponent extends InputComponent<null | number> implements OnInit {
    @Output() valueUpdated: EventEmitter<null | number> = new EventEmitter<null | number>();
    isLoading = false;
    value: null | number = null;
    reportsTo?: Employee;

    constructor(private auth: AuthService) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.isLoading = true;

        if (this.value) {
            Employee.param('company', this.auth.company.id)
                .find(this.value)
                .then((result) => (this.reportsTo = result))
                .catch(() => (this.reportsTo = undefined));
        }

        this.isLoading = false;
    }

    handleChange(): void {
        let newValue;

        if (this.reportsTo instanceof Employee) {
            newValue = this.reportsTo.id;
        } else {
            newValue = null;
        }

        if (this.value !== newValue) {
            this.value = newValue;
            this.valueUpdated.emit(this.value);
        }
    }
}
